import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import { ANALYTICS_ADMISSION_OFFICE } from '../constants/actionTypes'
import * as API from '../constants/api'

export const analyticsAdmissionOffice = createAsyncThunk(
  ANALYTICS_ADMISSION_OFFICE,
  async (
    params: PayloadCreatorParams<`${typeof API.ANALYTICS_ADMISSION_OFFICE}`, 'get'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.analyticsAdmissionOffice(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const analyticsAdmissionOfficeClear = createAction(`${ANALYTICS_ADMISSION_OFFICE}/clear`)
